import { css } from "styled-components";
import POSITIONS from "../consts";
import { left, right } from "../../utils/rtl/index";

var getPosition = function getPosition(_ref) {
  var position = _ref.position,
      theme = _ref.theme;
  return css(["", ":0;"], position === POSITIONS.RIGHT ? right({
    theme: theme
  }) : left({
    theme: theme
  }));
};

export default getPosition;